import React from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import { MediaDisplay, MediasProps } from '@/components/LegacyMediaContainer/types';

const ActionList: React.FC<
  Pick<MediasProps, 'actions' | 'onAction' | 'media'> & {
    displayMode?: MediaDisplay;
    className?: string;
  }
> = ({ actions, onAction, media, displayMode, className = 'absolute -top-8 -end-8' }) => {
  return actions?.length ? (
    <Box className={cn('flex flex-row space-s-8', className)}>
      {actions?.map((action) => (
        <action.renderer
          key={action.id}
          displayMode={displayMode}
          media={media}
          onAction={
            onAction
              ? (event: React.SyntheticEvent) => onAction(action.id, media, event)
              : undefined
          }
        />
      ))}
    </Box>
  ) : null;
};

export default ActionList;
